import React, { Component, ErrorInfo } from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class StandardsErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Standards tree error:', error, info); // eslint-disable-line no-console
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="tw-text-center tw-py-8 tw-text-dark-grey tw-text-sm">
          Something went wrong displaying the standards tree.
        </div>
      );
    }

    return children;
  }
}

export default StandardsErrorBoundary;
